/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ top: NonNullable<unknown>, days: NonNullable<unknown> }} Leveling_Reward_Top_OneInputs */



/**
* | output |
* | --- |
* | "Top {top} over {days} day" |
*
* @param {Leveling_Reward_Top_OneInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_reward_top_one = /** @type {((inputs: Leveling_Reward_Top_OneInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Reward_Top_OneInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Топ-${i?.top} за ${i?.days} день`)
	return /** @type {LocalizedString} */ (`Top ${i?.top} over ${i?.days} day`)
});